import { render, staticRenderFns } from "./DisplayCard.vue?vue&type=template&id=58dbd0b1&scoped=true"
import script from "./DisplayCard.vue?vue&type=script&lang=js"
export * from "./DisplayCard.vue?vue&type=script&lang=js"
import style0 from "./DisplayCard.vue?vue&type=style&index=0&id=58dbd0b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dbd0b1",
  null
  
)

export default component.exports